import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { BsChevronDown } from "react-icons/bs";
import { useLocation, useNavigate } from "react-router-dom";
import logo from "../../../assets/images/logo.png";
import logo1 from "../../../assets/images/logo1.png"; // Assurez-vous que le chemin est correct
import "./index.scss"; // Import du fichier SCSS
import { FlechBtn } from "../../../assets/icons/FlechBtn";
import { BergerIcon } from "../../../assets/icons/BergerIcon";
// Assurez-vous que le chemin est correct
const Header = () => {
  const location = useLocation();
  const [activeMenu, setActiveMenu] = useState(location.pathname); // Initialise avec la route actuelle
  const [showDropdown, setShowDropdown] = useState(false);
  const [showDropdownM, setShowDropdownM] = useState(false);
  const navigate = useNavigate();
  const handleNavigation = () => {
    navigate("/connexion");
    window.scrollTo(0, 0); // Navigue vers la page "About"
  };
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsMobile(width <= 768); // Mobile : ≤ 768px
    };
    handleResize(); // Vérifie la taille au chargement
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const [showModal, setShowModal] = useState(false);
  const toggleModal = () => {
    setShowModal(!showModal);
    setShowDropdownM(false);
  };
  const navVariants = {
    hidden: { opacity: 0, x: 100 }, // Départ : Hors écran à droite
    visible: {
      opacity: 1,
      x: 0, // Fin : À sa position d'origine
      transition: { duration: 1, ease: "easeOut" }, // Durée et effet
    },
  };
  return (
    <header className="header-container ">
      <div className=" w-100 d-flex justify-content-between align-items-center">
        {/* Logo Section */}

        {isMobile ? (
          <>
            <div className="logo ">
              {" "}
              <img className="logo-img " src={logo1} />
            </div>
            <button onClick={toggleModal} className="icon-btn">
              <BergerIcon />
            </button>
          </>
        ) : (
          <>
            <div className="logo" onClick={() => navigate("/")}>
              <img className="logo-img " src={logo} />
            </div>
            <nav className="nav-links w-100  d-flex justify-content-end align-items-center">
              <a
                href="/"
                className={`nav-link  ${activeMenu === "/" ? "active" : ""}`}>
                Accueil
              </a>
              <a
                href="/apropos"
                className={`nav-link  ${
                  activeMenu === "/apropos" ? "active" : ""
                }`}>
                A propos
              </a>

              <div
                className="nav-link dropdown-container"
                onMouseEnter={() => setShowDropdown(true)}
                onMouseLeave={() => setShowDropdown(false)}>
                <a
                  href="/services"
                  className={`nav-link ${
                    activeMenu === "/services" ? "active" : ""
                  }`}
                  onClick={() => setActiveMenu("/services")}>
                  Nos Services <BsChevronDown />
                </a>
                {showDropdown && (
                  <div className="dropdown-menu1">
                    <a href="/ITE" className="dropdown-item1">
                      Isolation extérieur (ITE)
                    </a>
                    <a href="/ITI" className="dropdown-item1">
                      Isolation intérieure (ITI)
                    </a>
                    <a href="/toiture" className="dropdown-item1">
                      Isolation de toiture
                    </a>
                    <a href="/ravalement-façade" className="dropdown-item1">
                      Ravalement de façade
                    </a>
                    <a
                      href="/renovation-investisseurs"
                      className="dropdown-item1">
                      Rénovation globale
                    </a>
                    <a
                      href="/accompagnement-administratif"
                      className="dropdown-item1">
                      Accompagnement administratif
                    </a>
                  </div>
                )}
              </div>

              <a
                href="/blogs"
                className={`nav-link  ${
                  activeMenu === "/blogs" ? "active" : ""
                }`}>
                Blogs
              </a>

              <div>
                {" "}
                <a class="btn-slide" href="/contact">
                  <span class="circle">
                    <FlechBtn />
                  </span>

                  <span class="title">Contactez-nous</span>
                  <span class="title title-hover">Contactez-nous</span>
                </a>{" "}
              </div>
            </nav>
          </>
        )}
        {/* Navigation Links */}
      </div>
      <Modal
        show={showModal}
        onHide={toggleModal}
        dialogClassName="fade-right"
        className="mm-kra">
        <Modal.Body>
          {" "}
          <nav
            className="nav-links d-flex justify-content-center align-items-center mt-5 flex-column mobile-nav "
            initial="hidden" // État initial
            animate="visible" // État final
            variants={navVariants} // Définit les animations
          >
            <a href="/" className="nav-link nav-m ">
              Accueil
            </a>
            <a href="/apropos" className="nav-link nav-m ">
              A propos
            </a>
            <div
              className=" nav-link nav-m"
              onMouseEnter={() => setShowDropdownM(true)}
              onMouseLeave={() => setShowDropdownM(false)}>
              <a href="/services" className="nav-m1">
                Nos Services
                <BsChevronDown />
              </a>
              {showDropdownM && (
                <div className="">
                  <a href="/ITE" className="nav-link nav-m2 mt-3 ">
                    Isolation extérieur (ITE)
                  </a>
                  <a href="/ITI" className="nav-link nav-m2 mt-3">
                    Isolation intérieure (ITI)
                  </a>
                  <a href="/toiture" className="nav-link nav-m2 mt-3">
                    Isolation de toiture
                  </a>
                  <a
                    href="/ravalement-façade"
                    className="nav-link nav-m2 mt-3 ">
                    Ravalement de façade
                  </a>
                  <a
                    href="/renovation-investisseurs"
                    className="nav-link nav-m2 mt-3 ">
                    Rénovation globale
                  </a>
                  <a
                    href="/accompagnement-administratif"
                    className="nav-link nav-m2 mt-3 ">
                    Accompagnement administratif
                  </a>
                </div>
              )}
            </div>
            <a href="/blogs" className="nav-link nav-m ">
              Blogs
            </a>
            <a href="/contact" className="nav-link nav-m ">
              Contact
            </a>
          </nav>
        </Modal.Body>
      </Modal>
    </header>
  );
};

export default Header;
